export const addClickOutsideListener = (element: HTMLDialogElement) => {
    element.addEventListener("click", (event: MouseEvent) => {
        const target: HTMLElement = event.target as HTMLElement;
        let rect: DOMRect = target.getBoundingClientRect();

        if (
            rect.left > event.clientX ||
            rect.right < event.clientX ||
            rect.top > event.clientY ||
            rect.bottom < event.clientY
        ) {
            element.close();
        }
    });
};
